import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DailyProductUsage from './daily-product-usage';
import DailyProductUsageDetail from './daily-product-usage-detail';
import DailyProductUsageUpdate from './daily-product-usage-update';
import DailyProductUsageDeleteDialog from './daily-product-usage-delete-dialog';

const DailyProductUsageRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DailyProductUsage />} />
    <Route path="new" element={<DailyProductUsageUpdate />} />
    <Route path=":id">
      <Route index element={<DailyProductUsageDetail />} />
      <Route path="edit" element={<DailyProductUsageUpdate />} />
      <Route path="delete" element={<DailyProductUsageDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DailyProductUsageRoutes;
